import Rollbar from 'rollbar'

const rollbar = new Rollbar({
  accessToken: process.env.CAMPAIGN_ROLLBAR_ACCESS_TOKEN,
  // enabled: process.env.NODE_ENV === "production",
  enabled: true,
  captureUncaught: true,
  captureUnhandledRejections: true,
  captureIp: 'anonymize',
  payload: {
    environment: process.env.NODE_ENV,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.npm_package_version,
        // Optionally have Rollbar guess which frames the error was thrown from
        // when the browser does not provide line and column numbers.
        guess_uncaught_frames: true,
      },
    },
  },
  autoInstrument: {
    network: true,
    log: true,
    dom: true,
    navigation: true,
    connectivity: true,
  },
})

export default rollbar
